import { ExternalAssetForm } from '@/components/externalAssets/ExternalAssetForm'
import { ExternalAssetList } from '@/components/externalAssets/ExternalAssetList'

export function Step5ExternalAssets() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="tracked-caps text-sm text-ink">External Assets</h2>
        <p className="mt-3 max-w-2xl font-mono text-sm leading-6 text-muted">
          Werte, die Sextant beobachtet aber nicht verwaltet — z.B. BTC via CoinTracking,
          Immobilien, physisches Gold. Du pflegst den EUR-Wert manuell (1× pro Monat empfohlen).
        </p>
      </div>

      <section className="hairline-y py-5">
        <p className="tracked-caps mb-4 text-[10px] text-faint">Asset hinzufügen</p>
        <ExternalAssetForm />
      </section>

      <section>
        <p className="tracked-caps mb-3 text-[10px] text-faint">Angelegte Assets</p>
        <ExternalAssetList />
      </section>
    </div>
  )
}
